import fetch from './fetch';
import {API_VERSION_STRING} from '../../const';

export default {
  getSearchSettings: function(payload = {}) {
    return fetch(payload.baseUrl, '/search_settings?valuebets=true', 'get', payload);
  },
  getFilters: function({baseUrl, accessToken, locale, version}) {
    const versionParam = version ? `&version=${version}` : '';
    const url = `/${API_VERSION_STRING}value_bet_filters?access_token=${accessToken}&locale=${locale}${versionParam}`;
    return fetch(baseUrl, url, 'get');
  },
  saveFilter: function({baseUrl, accessToken, locale, id, payload}) {
    const url = `/${API_VERSION_STRING}value_bet_filters/${id}?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'put', payload);
  },
  putNewSearchFiltersToServer: function(payload) {
    const {baseUrl, accessToken, filterId, isActive, locale} = payload;
    const url = `/${API_VERSION_STRING}value_bet_filters/${filterId}/active/${isActive}?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'get');
  },
  getFreeFilters: function({baseUrl, locale, version}) {
    const versionParam = version ? `&version=${version}` : '';
    const url = `/${API_VERSION_STRING}value_bet_free_filters?access_token=&locale=${locale}${versionParam}`;
    return fetch(baseUrl, url, 'get');
  },
  getArbsProSearch: function({baseUrl, accessToken, locale, payload}) {
    const url = `/${API_VERSION_STRING}valuebets/pro_search?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post', payload);
  },
  getValuebetsProSearch: function({baseUrl, accessToken, locale, payload}) {
    const url = `/api/v2/valuebets/pro_search?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post', payload);
  },
  getSameBets: function({baseUrl, accessToken, locale, betId}) {
    const url = `/${API_VERSION_STRING}bets/${betId}/same_bets?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'get');
  },
  // getAloneArbInfo: function({baseUrl, accessToken, locale, arbId}) {
  //   const url = `/${API_VERSION_STRING}arbs_by_hash/${arbId}?access_token=${accessToken}&locale=${locale}`;
  //   return fetch(baseUrl, url, 'get');
  // },
  putNewSearchSettingToServer: function(payload) {
    return fetch(undefined, `/update_search_settings.json`, 'put', payload);
  },
  sendWrongItems: function({baseUrl, accessToken, locale, arbId, payload}) {
    const url = `/${API_VERSION_STRING}wrong_items/${arbId}?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post', payload);
  },
  excludeBets: function({baseUrl, accessToken, locale, betId}) {
    const url = `/${API_VERSION_STRING}excluded/bets/${betId}?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post');
  },
  excludeArb: function({baseUrl, accessToken, locale, arbId}) {
    const url = `/${API_VERSION_STRING}excluded/arbs/${arbId}?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post');
  },
  excludeEvent: function({baseUrl, accessToken, locale, eventId}) {
    const url = `/${API_VERSION_STRING}excluded/events/${eventId}?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post');
  },
  excludeBkEvent: function({baseUrl, accessToken, locale, eventId}) {
    const url = `/${API_VERSION_STRING}excluded/bk_events/${eventId}?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'post');
  },
  getMessages: function({baseUrl, pageType, locale, packageType = 'valuebets'}) {
    const url = `/settings/info?node=${pageType}&package=${packageType}&locale=${locale}`;
    return fetch(baseUrl, url, 'get');
  },
  getProSameBets: function({baseUrl, accessToken, locale, betId}) {
    const url = `/${API_VERSION_STRING}value_bets/${betId}/same?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'get');
  },
  getIncorrectArbMessage: function({baseUrl, accessToken, locale, arbHash}) {
    const url = `/${API_VERSION_STRING}arbs/${arbHash}/wrong?access_token=${accessToken}&locale=${locale}`;
    return fetch(baseUrl, url, 'get');
  },
  sendReport: function(payload) {
    return fetch(undefined, `/arbs/report`, 'post', payload);
  },
  profileImport: function(payload) {
    return fetch(undefined, `/profile/import`, 'post', payload);
  },
  sendArbHelperStat: function({baseUrl, accessToken, locale}) {
    return fetch(baseUrl, `/arb_helper?access_token=${accessToken}&locale=${locale}`, 'get');
  },
};
